export const SCHEMA_NAME = "ServiceAttempts";

export const FIELDS = {
  SERVICE_ATTEMPT_ID: "serviceAttemptID",
  SERVICE_TYPE_ID: "serviceTypeID",
  ATTEMPT_DATE: "attemptDate",
  ATTEMPT_TIME: "attemptTime",
  ATTEMPT_BY_STAFF_ID: "attemptByStaffID",
  MILEAGE: "mileage",
  NARRATIVE: "narrative",
  SUCCESSFUL: "successful",
  SERVICE_ROUND_ID: "serviceRoundID",
  CREATOR_STAFF_ID: "creatorStaffID",
  JACKET_ID: "jacketID",
  BIO_ID: "bioID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  USER: "user",
  ATTEMPT_ADDRESS_ID: "attemptAddressID",
  CERTIFICATE_COMMENTS: "certificateComments",
  DEPUTY_TIME: "deputyTime",
};
